export const mapImages = [
    { name: "Carentan", identifier: "ct", src: "img/map-previews/ct.png" },
    { name: "Driel", identifier: "driel", src: "img/map-previews/driel.png" },
    { name: "El Alamein", identifier: "elalamein", src: "img/map-previews/elalamein.png" },
    { name: "Elsenborn Ridge", identifier: "elsenborn", src: "img/map-previews/elsenborn.png" },
    { name: "Foy", identifier: "foy", src: "img/map-previews/foy.jpg" },
    { name: "Hill 400", identifier: "hill400", src: "img/map-previews/hill400.jpg" },
    { name: "Hürtgen Forest", identifier: "hurtgen", src: "img/map-previews/hurtgen.jpg" },
    { name: "Kharkov", identifier: "kharkov", src: "img/map-previews/kharkov.jpg" },
    { name: "Kursk", identifier: "kursk", src: "img/map-previews/kursk.jpg" },
    { name: "Mortain", identifier: "mortain", src: "img/map-previews/mortain.jpg" },
    { name: "Omaha Beach", identifier: "omaha", src: "img/map-previews/omaha.jpg" },
    { name: "Purple Heart Lane", identifier: "phl", src: "img/map-previews/phl.jpg" },
    { name: "Remagen", identifier: "remagen", src: "img/map-previews/remagen.jpg" },
    { name: "Sainte-Mère-Église", identifier: "sme", src: "img/map-previews/sme.jpg" },
    { name: "Stalingrad", identifier: "stalin", src: "img/map-previews/stalin.jpg" },
    { name: "Sainte-Marie-du-Mont", identifier: "stmarie", src: "img/map-previews/stmarie.jpg" },
    { name: "Utah Beach", identifier: "utah", src: "img/map-previews/utah.jpg" },
];